import { useState } from 'react';
import { builderDispatch } from '../../../_utils/ui';
import { UpdatePhotoEvents } from '../../common/events/event-declarations';

export function useMultiSelect({ photos, isActive }) {
  const [multiSelectPhotos, setMultiSelectPhotos] = useState({});

  function emptySelectedItems() {
    setMultiSelectPhotos({});
  }

  function handleMultiSelectAll() {
    setMultiSelectPhotos(
      photos.reduce((memo, photo) => {
        return {
          ...{
            [uniqueKey(photo)]: [photo.image_id],
            ...memo,
          },
        };
      }, {})
    );
  }

  function handleMultiUnSelectAll() {
    emptySelectedItems();
  }

  const handleMultiResize = targetSizeKey => {
    builderDispatch.dispatch({
      type: UpdatePhotoEvents.RESIZE_MULTI_SELECT,
      selectPhotoImageIds,
      targetSizeKey,
    });

    emptySelectedItems();
  };

  function handleMultiDelete() {
    const photosToDelete = photos.filter(
      photo => multiSelectPhotos[uniqueKey(photo)]?.length
    );

    photosToDelete.forEach(photo => {
      const {
        size: { key },
        image_id: imageId,
      } = photo;

      builderDispatch.dispatch({
        type: UpdatePhotoEvents.REMOVE,
        sizeKey: key,
        imageId,
      });
    });

    emptySelectedItems();
  }

  function handleMultiSelectItem(photo) {
    const photoKey = uniqueKey(photo);

    if (isMultiSelected(photo)) {
      const photos = multiSelectPhotos[photoKey].filter(
        imageId => photo.image_id !== imageId
      );
      return setMultiSelectPhotos({
        ...multiSelectPhotos,
        ...{ [photoKey]: photos },
      });
    }

    setMultiSelectPhotos({
      ...multiSelectPhotos,
      ...{ [photoKey]: [photo.image_id] },
    });
  }

  function isMultiSelected(photo) {
    return (multiSelectPhotos[uniqueKey(photo)] || []).some(
      imageId => imageId === photo?.image_id
    );
  }

  function uniqueKey(photo) {
    return `${photo.image_id}_${photo.size.size_id}`;
  }

  const selectPhotoImageIds = Object.values(multiSelectPhotos).flatMap(
    photoImageId => photoImageId
  );
  const multiSelectItemsCount = selectPhotoImageIds.length;
  const maximumSelected = multiSelectItemsCount === photos.length;

  return {
    maximumSelected,
    isMultiSelected,
    handleMultiSelectItem,
    handleMultiSelectAll,
    handleMultiUnSelectAll,
    handleMultiResize,
    handleMultiDelete,
    multiSelectItemsCount,
  };
}
